import ErrorView from 'components/errorViewSelector/errorView/ErrorView';
import { IErrorProps } from 'components/errorViewSelector/ErrorViewSelector';
import { APP_STATUS, AppState, ERROR_SCREEN_TYPES } from 'config/config';
import getRouteWithParams from 'helpers/getRouteWithParams';
import withLocaleContext from 'hoc/withLocaleContext';
import React, { Component } from 'react';
import { getPaymentDetails } from 'services/Api';
import License from 'types/License';
import { IPayment } from 'types/Payment';

import { IAppState } from 'types/ApplicationState';
import withLicenseNoteContext from '../../hoc/withLicenseNoteContext';

import { getExistingPaymentStatus } from '../appCallback/getExistingPaymentStatus/getExistingPaymentStatus';
import PaymentInitFailScreen from './paymentInitFailScreen/PaymentInitFailScreen';
import { IAppPaymentInitFailProps, IAppPaymentInitFailState } from './AppPaymentInitFail.types';
import withAppStateContext from '../../hoc/withAppStateContext';

type LocationState = {
  status;
};

class AppPaymentInitFail extends Component<
  IAppPaymentInitFailProps & Partial<ILicenseNoteContext> & Partial<ILocaleContext> & Partial<IAppState>,
  IAppPaymentInitFailState
> {
  constructor(props) {
    super(props);
    const { location } = this.props;
    this.state = {
      isLoading: true,
      redirectUrl: '',
      status: location.state && (location.state as LocationState).status,
      isPaymentMethodSelected: false,
    };
  }

  async componentDidMount() {
    try {
      const {
        match: {
          params: { paymentId },
        },
        setPaymentDetails,
        setLicense,
        setLocaleFromPaymentRequest,
        setAppState,
      } = this.props;
      const paymentStatus: string = await getExistingPaymentStatus(paymentId);
      const paymentDetails: IPayment = await getPaymentDetails(paymentId);
      setAppState?.(AppState.INIT_FIELD);

      if (setLicense) {
        if (paymentDetails.license) {
          setLicense(paymentDetails.license);
        } else {
          setLicense(License.MBANK);
        }
      }

      if (setLocaleFromPaymentRequest) {
        setLocaleFromPaymentRequest(paymentDetails.locale);
      }

      const customQueryParams = { paymentId, paymentStatus };
      const redirectUrl = getRouteWithParams(paymentDetails.continueUrl, customQueryParams);
      const isPaymentMethodSelected = paymentDetails.selectedPaymentMethodId != null;

      setPaymentDetails(paymentDetails, paymentId);
      this.setState({
        status: paymentStatus,
        isLoading: false,
        redirectUrl,
        isPaymentMethodSelected,
      });
    } catch (error) {
      this.setState(() => {
        const castedError: IErrorProps = error as IErrorProps;
        castedError.screenType = this.handleErrorScreenType(castedError.message, castedError.screenType);
        throw castedError;
      });
    }
  }

  handleErrorScreenType = (errorType?: string, defaultView?: string) => {
    switch (errorType) {
      case 'TOKEN_EXPIRED': {
        return ERROR_SCREEN_TYPES.STATUS_TOKEN_EXPIRED;
      }
      default: {
        return defaultView || ERROR_SCREEN_TYPES.PAYMENT;
      }
    }
  };

  statusToView = () => {
    const { status, redirectUrl, isPaymentMethodSelected } = this.state;

    if (status === APP_STATUS.NEW) {
      return <PaymentInitFailScreen redirectUrl={redirectUrl} isPaymentMethodSelected={isPaymentMethodSelected} />;
    }

    return <ErrorView />;
  };

  render() {
    const { isLoading } = this.state;

    if (isLoading) {
      return false;
    }

    return this.statusToView();
  }
}

export default withLicenseNoteContext(withLocaleContext(withAppStateContext(AppPaymentInitFail)));
